import { useState, useEffect } from 'react';

const useCareerLogic = () => {
  // כאן ניתן להוסיף את הלוגיקה של הדף
  // לדוגמה: טעינת נתונים, מצבים, אפקטים וכו'

  return {
    // כאן יוחזרו הנתונים והפונקציות שישמשו את התצוגה
  };
};

export default useCareerLogic; 